import React, { Component } from 'react'

export default class TargetRadio extends Component {
    render() {
        const { options, onChange, showCorrect, answer, correctAnswer } = this.props;
        console.log(showCorrect);
        return (
            <>
                {options.map((o,i) =>{
                    const inputId = `targetradio-${i}`;
                    
                    return  <div key={inputId+'-wrap'} className={`form-check px-5 py-0 my-2 border rounded ${showCorrect?(correctAnswer===o?'alert alert-success text-success':'alert alert-danger text-danger'):''}`}>
                    <input className="form-check-input my-3" style={{position:'relative',top:'3px'}} value={o} onChange={onChange} type="radio" checked={answer === o} name="flexRadioDefault" id={inputId} />
                    <label className="form-check-label w-100 py-3" htmlFor={inputId}>
                        {o}
                    </label>
                </div>})}
            </>
            
        )
    }
}
